define("shared/utils/self-describes", ["exports", "@ember/template", "later/utils/constants"], function (_exports, _template, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.surveyQuestions = surveyQuestions;
  0; //eaimeta@70e063a35619d71f0,"@ember/template",0,"later/utils/constants"eaimeta@70e063a35619d71f
  const IMAGE_BLOCK_SELECTOR = 'image-block-selector';
  const SINGLE_CHOICE_SELECTOR = 'single-choice-selector';
  const TEXT_INPUT = 'text-input';
  const COMPONENT_PREFIX = 'shared/pre-boarding/survey-components/';
  function surveyQuestions(intl, userModel) {
    const userName = userModel.name?.split(' ')[0] || '';
    return [[{
      identifier: 'bestDescribes',
      surveyComponentName: `${COMPONENT_PREFIX}${IMAGE_BLOCK_SELECTOR}`,
      text: intl.t('onboarding.self_describes.best_describes.question', {
        name: userName.charAt(0).toUpperCase() + userName.slice(1)
      }),
      subText: intl.t('onboarding.self_describes.intro_text'),
      class: 'tUG--questionCard__input--col__3',
      options: [{
        icon: '/assets/images/img--bestDescribe--role--social_media_manager.svg',
        text: intl.t('onboarding.self_describes.best_describes.options.social_media_manager'),
        subText: intl.t('onboarding.self_describes.best_describes.options.detail.social_media_manager'),
        qaClass: 'qa--self_desc_role_smm',
        value: 'social_media_manager'
      }, {
        icon: '/assets/images/img--bestDescribe--role--freelancer.svg',
        text: intl.t('onboarding.self_describes.best_describes.options.marketing_agency'),
        subText: intl.t('onboarding.self_describes.best_describes.options.detail.marketing_agency'),
        qaClass: 'qa--self_desc_role_agency',
        value: 'marketing_agency'
      }, {
        icon: '/assets/images/img--bestDescribe--role--influencer_marketing_manager.svg',
        text: intl.t('onboarding.self_describes.best_describes.options.influencer_marketing_manager'),
        subText: intl.t('onboarding.self_describes.best_describes.options.detail.influencer_marketing_manager'),
        qaClass: 'qa--self_desc_role_influencer_marketing_manager',
        value: 'influencer_marketing_manager'
      }, {
        icon: '/assets/images/img--bestDescribe--role--creator.svg',
        text: intl.t('onboarding.self_describes.best_describes.options.creator'),
        subText: intl.t('onboarding.self_describes.best_describes.options.detail.creator'),
        qaClass: 'qa--self_desc_role_creator',
        value: 'creator'
      }, {
        icon: '/assets/images/img--bestDescribe--role--small_business_owner.svg',
        text: intl.t('onboarding.self_describes.best_describes.options.small_business_owner'),
        subText: intl.t('onboarding.self_describes.best_describes.options.detail.small_business_owner'),
        qaClass: 'qa--self_desc_role_smb',
        value: 'small_business_owner'
      }, {
        icon: '/assets/images/img--bestDescribe--role--other.svg',
        text: intl.t('onboarding.self_describes.best_describes.options.other'),
        subText: (0, _template.htmlSafe)(intl.t('onboarding.self_describes.best_describes.options.detail.other')),
        qaClass: 'qa--self_desc_role_other',
        value: 'other'
      }]
    }, {
      identifier: 'bestDescribesOther',
      text: intl.t('onboarding.self_describes.other.question'),
      placeholder: intl.t('onboarding.self_describes.best_describes.options.other_validation'),
      surveyComponentName: `${COMPONENT_PREFIX}${TEXT_INPUT}`,
      class: '',
      shouldHideByDefault: true,
      options: [{
        text: '',
        qaClass: ''
      }]
    }], [{
      identifier: 'companySize',
      surveyComponentName: `${COMPONENT_PREFIX}${IMAGE_BLOCK_SELECTOR}`,
      text: intl.t('onboarding.self_describes.company_size.question'),
      subText: intl.t('onboarding.self_describes.intro_text'),
      class: 'tUG--questionCard__input--col__2',
      options: [{
        icon: '/assets/images/img--bestDescribe--company_size--small.svg',
        text: intl.t('onboarding.self_describes.company_size.options.small'),
        qaClass: 'qa--self_desc_compSize_1_20_ppl',
        value: '1_20_people'
      }, {
        icon: '/assets/images/img--bestDescribe--company_size--medium.svg',
        text: intl.t('onboarding.self_describes.company_size.options.medium'),
        qaClass: 'qa--self_desc_compSize_21_100_ppl',
        value: '21_100_people'
      }, {
        icon: '/assets/images/img--bestDescribe--company_size--large.svg',
        text: intl.t('onboarding.self_describes.company_size.options.large'),
        qaClass: 'qa--self_desc_compSize_101_999_ppl',
        value: '101_999_people'
      }, {
        icon: '/assets/images/img--bestDescribe--company_size--xLarge.svg',
        text: intl.t('onboarding.self_describes.company_size.options.xlarge'),
        qaClass: 'qa--self_desc_compSize_over_1000_ppl',
        value: 'over_1000_people'
      }]
    }, {
      identifier: 'companyName',
      text: intl.t('onboarding.self_describes.company_size.company_name'),
      placeholder: intl.t('onboarding.self_describes.company_size.company_name_placeholder'),
      surveyComponentName: `${COMPONENT_PREFIX}${TEXT_INPUT}`,
      class: '',
      shouldHideByDefault: true,
      options: [{
        text: '',
        qaClass: ''
      }]
    }], [{
      identifier: 'teamSize',
      surveyComponentName: `${COMPONENT_PREFIX}${IMAGE_BLOCK_SELECTOR}`,
      text: intl.t('onboarding.self_describes.team_size.question'),
      subText: intl.t('onboarding.self_describes.intro_text'),
      class: 'tUG--questionCard__input--col__2',
      options: [{
        icon: '/assets/images/img--bestDescribe--team_size--small.svg',
        text: intl.t('onboarding.self_describes.team_size.options.small'),
        value: _constants.ONBOARDING_TEAMSIZE.JUST_ME,
        qaClass: 'qa--self_desc_teamSize_just_me'
      }, {
        icon: '/assets/images/img--bestDescribe--team_size--large.svg',
        text: intl.t('onboarding.self_describes.team_size.options.medium'),
        value: _constants.ONBOARDING_TEAMSIZE.TWO_TO_FIVE,
        qaClass: 'qa--self_desc_teamSize_2_5_ppl'
      }, {
        icon: '/assets/images/img--bestDescribe--team_size--xLarge.svg',
        text: intl.t('onboarding.self_describes.team_size.options.xlarge'),
        value: _constants.ONBOARDING_TEAMSIZE.MORE,
        qaClass: 'qa--self_desc_teamSize_over_6_ppl'
      }]
    }], [{
      identifier: 'reasonForUsingLater',
      surveyComponentName: `${COMPONENT_PREFIX}${SINGLE_CHOICE_SELECTOR}`,
      text: intl.t('onboarding.self_describes.reason.question'),
      subText: intl.t('onboarding.self_describes.intro_text'),
      class: 'tUG--questionCard__input--col__2',
      options: [{
        text: intl.t('onboarding.self_describes.reason.options.scheduling_and_publishing'),
        qaClass: 'qa--self_desc_reason_schedule',
        value: 'scheduled_publishing'
      }, {
        text: intl.t('onboarding.self_describes.reason.options.creating_a_bio_link_page'),
        qaClass: 'qa--self_desc_reason_lib',
        value: 'creating_bio_link_page'
      }, {
        text: intl.t('onboarding.self_describes.reason.options.collaborating'),
        qaClass: 'qa--self_desc_reason_collabs',
        value: 'collabs_with_creators_brands'
      }]
    }]];
  }
});